import { recordTypes } from "../../../../../../API/config";

export const processPermissionState = (
  existingPermissionObjectFromDb = {},
  defaultPermissions = {}
) => {
  const newPermission = JSON.parse(
    JSON.stringify(existingPermissionObjectFromDb)
  );
  const globalPermission = newPermission["*"] || {};

  for (let rt in defaultPermissions) {
    let rtPermission = newPermission[rt];
    //rtPermission =  {create : true, search: false}
    if (!rtPermission) {
      rtPermission = newPermission["*"] || {};
    }
    if (rt === "*") continue;
    for (let action in defaultPermissions[rt]) {
      let initialValueOfActionPerm = rtPermission[action];
      //initialValue = create : true || create { conditions }
      if (typeof initialValueOfActionPerm === "object") {
        initialValueOfActionPerm = true;
      }
      if (initialValueOfActionPerm === undefined) {
        initialValueOfActionPerm = rtPermission["*"];
      }
      if (initialValueOfActionPerm === undefined) {
        initialValueOfActionPerm = globalPermission["*"] || false;
      }
      if (action === "*") continue;
      defaultPermissions[rt][action]["accessStatus"] = initialValueOfActionPerm;
      if (newPermission.hasOwnProperty(rt)) {
        if (
          newPermission[rt].hasOwnProperty(action) &&
          typeof newPermission[rt][action] === "object"
        ) {
          for (let cond in newPermission[rt][action]) {
            if (typeof newPermission[rt][action][cond] === "boolean") {
              defaultPermissions[rt][action]["conditions"][cond][
                "isSelected"
              ] = true;
              for (let pv of defaultPermissions[rt][action]["conditions"][cond][
                "possibleValues"
              ]) {
                if (
                  newPermission[rt][action][cond] === true &&
                  pv.value === "true" &&
                  pv.label === "True"
                ) {
                  pv["isTicked"] = true;
                  break;
                }
                if (
                  newPermission[rt][action][cond] === false &&
                  pv.value === "false" &&
                  pv.label === "False"
                ) {
                  pv["isTicked"] = true;
                  break;
                }
              }
            }
            if (Array.isArray(newPermission[rt][action][cond])) {
              defaultPermissions[rt][action]["conditions"][cond][
                "isSelected"
              ] = true;
              for (let pv of newPermission[rt][action][cond]) {
                for (let pvofDefCond of defaultPermissions[rt][action][
                  "conditions"
                ][cond]["possibleValues"]) {
                  if (pv === pvofDefCond.label || pv === pvofDefCond.value) {
                    pvofDefCond["isTicked"] = true;
                    break;
                  }
                }
              }
            }
          }
        }
      }
    }
    if (
      newPermission.hasOwnProperty(rt) &&
      newPermission[rt].hasOwnProperty("*")
    ) {
      defaultPermissions[rt]["*"] = newPermission[rt]["*"];
    }
  }
  if (newPermission.hasOwnProperty("*")) {
    defaultPermissions["*"] = JSON.parse(JSON.stringify(newPermission["*"]));
  }

  for (let rt in recordTypes) {
    let rtPermission = newPermission[recordTypes[rt].name];
    if (!rtPermission) {
      rtPermission = newPermission["*"] || {};
    }
    if (!newPermission[recordTypes[rt].name]) {
      newPermission[recordTypes[rt].name] = {};
    }
    const actions = Object.keys(recordTypes[rt].actions)
      .map((a) => recordTypes[rt].actions[a])
      .filter((a) => !a.internal && !a.legacy);
    for (let action of actions) {
      let defaultValueOfActionPermission = rtPermission[action.name];
      if (typeof defaultValueOfActionPermission === "object") {
        defaultValueOfActionPermission = rtPermission[action.name]
          ? true
          : undefined;
      }

      if (defaultValueOfActionPermission === undefined) {
        defaultValueOfActionPermission = rtPermission["*"];
      }

      if (defaultValueOfActionPermission === undefined) {
        defaultValueOfActionPermission = globalPermission["*"] || false;
      }
      if (newPermission[recordTypes[rt].name][action.name] === undefined) {
        newPermission[recordTypes[rt].name][action.name] = {
          accessStatus: defaultValueOfActionPermission,
        };
      } else {
        if (
          typeof newPermission[recordTypes[rt].name][action.name] === "object"
        ) {
          if (
            newPermission[recordTypes[rt].name][action.name]["accessStatus"] ===
            undefined
          ) {
            const prevVal = JSON.parse(
              JSON.stringify(newPermission[recordTypes[rt].name][action.name])
            );
            newPermission[recordTypes[rt].name][action.name] = {
              accessStatus: defaultValueOfActionPermission,
              conditions: { ...prevVal },
            };
          }
        } else {
          newPermission[recordTypes[rt].name][action.name] = {
            accessStatus: defaultValueOfActionPermission,
          };
        }
      }
    }
  }
  return { defaultPermissions, newPermission };
};
